import React, { useState, useEffect } from "react";
import { Menu, X, Trees } from "lucide-react";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#inicio", label: "Início" },
    { href: "#sobre", label: "Sobre" },
    { href: "#chales", label: "Chalés" },
    { href: "#reserva", label: "Reserva" },
    { href: "#faq", label: "FAQ" },
    { href: "#contato", label: "Contato" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#f7f5f0]/95 backdrop-blur-md border-b border-[#d1cfc3] shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-4 flex items-center justify-between">
        <a
          href="#inicio"
          data-testid="brand-link"
          className={`flex items-center gap-2 font-bold tracking-tight ${
            scrolled ? "text-[#1a3622]" : "text-white drop-shadow"
          }`}
        >
          <Trees className="h-6 w-6" strokeWidth={2.25} />
          <span className="text-lg sm:text-xl">Cabanas Igaratá</span>
        </a>

        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className={`text-sm font-medium tracking-wide hover:opacity-70 transition-opacity ${
                scrolled ? "text-[#1a3622]" : "text-white drop-shadow"
              }`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#reserva"
            data-testid="header-cta"
            className="rounded-full bg-[#1a3622] text-[#f7f5f0] px-5 py-2 text-sm font-semibold hover:bg-[#2d5638] transition-colors"
          >
            Reservar agora
          </a>
        </nav>

        <button
          aria-label="Abrir menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className={`md:hidden p-2 rounded-md ${
            scrolled ? "text-[#1a3622]" : "text-white"
          }`}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#f7f5f0] border-t border-[#d1cfc3] px-5 py-4 flex flex-col gap-4"
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.href.slice(1)}`}
              className="text-[#1a3622] font-medium"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#reserva"
            onClick={() => setOpen(false)}
            className="rounded-full bg-[#1a3622] text-[#f7f5f0] px-5 py-2 text-sm font-semibold text-center"
          >
            Reservar agora
          </a>
        </div>
      )}
    </header>
  );
};
